import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import DataTableSurveillanceJour from "./DataTableSurveillanceJour"

const SurveillanceJour = props => {
  const [section, setSection] = useState(1)

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableSurveillanceJour />
    } 
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Surveillance | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  Emploi surveillance par jour (semestre 1)
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(SurveillanceJour)
